import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import { Mutation } from 'react-apollo'
import classNames from 'classnames'

import { loginValidation } from '../../lib/validators'
import TextInput from '../ui/form/TextInput'
import PasswordInput from '../ui/form/PasswordInput'
import { loginMutation } from '../../lib/graphql/user'

const LoginForm = (props) => {
  return (
    <Mutation
      mutation={loginMutation}
      onCompleted={(data) => {
        props.onCompleted(data.login)
      }}
      onError={(error) => {
        props.onError(error)
      }}
    >
      {(login) => (
        <Form
          validate={loginValidation}
          onSubmit={async ({ username = '', password = '' }) => {
            props.onSubmit()
            await login({
              variables: {
                username,
                password,
              },
            })
          }}
        >
          {({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit}>
              <TextInput
                name="username"
                placeholder="idUFFS"
                autoComplete="username"
                autoFocus={true}
                autoCapitalize="off"
              />

              <PasswordInput
                name="password"
                placeholder="Senha"
                autoComplete="current-password"
              />

              <button
                className={classNames(
                  'button is-primary is-medium is-fullwidth',
                  {
                    'is-loading': submitting,
                  }
                )}
                style={{ marginTop: '20px' }}
                type="submit"
              >
                Entrar
              </button>
            </form>
          )}
        </Form>
      )}
    </Mutation>
  )
}

LoginForm.propTypes = {
  onSubmit: PropTypes.func,
  onCompleted: PropTypes.func,
  onError: PropTypes.func,
}

LoginForm.defaultProps = {
  onSubmit: () => {},
  onCompleted: () => {},
  onError: () => {},
}

export default LoginForm
